<template>
  <ClaimEmailed
    header="Light Commercial - Claim Emailed"
    title="Commercial Vehicle Insurance"
    subtitle="Claim Sent"
    body="A new light vehicle claim has been sent on your behalf."
    :action="newClaim"
  />
</template>

<script>
import ClaimEmailed from "@/components/ClaimEmailed.vue";

export default {
  methods: {
    newClaim() {
      this.$router.push("/lightCommercial/submitClaim");
    }
  },
  components: {
    ClaimEmailed
  }
};
</script>
